<stages-auto-complete
	(backButtonPressed)="back()"
	(closeButtonPressed)="closeButtonPressed.emit()"
	(escapeKeyPressed)="cancelled.emit()"
	(focusLost)="focusLost.emit($event)"
	(itemSelected)="itemSelected($event)"
	(searchInput)="onSearchInput($event)"
	(openBrowserButtonPressed)="openBrowserButtonPressed.emit()"
	[backButtonActive]="backButtonActive"
	[browseButtonActive]="browseButtonActive"
	[createDependendElementAllowedCallback]="isCreateAllowed"
	[dropDownClass]="dropDownClass"
	[focusOnInit]="focusOnInit"
	[inputIconClasses]="inputIconClasses"
	[isDense]="isDense"
	[subordinatedResults]="subordinatedResults"
	[placeholder]="placeholder"
	[searchEngineAvailable]="searchEngineAvailable"
	[searchResultSeparatorTemplate]="searchResultSeparatorTemplate"
	[searchResultTemplate]="searchResultTemplate"
	[term]="currentTerm"
	[maxTermLength]="maxSearchTermLength"
	[minTermLength]="minSearchTermLength"
	[results]="results"
	[isLoading]="loading"
></stages-auto-complete>
